/**
 * The searching state is split into mutable and immutable state. Both may come pre-loaded from the server or the URL,
 * but only the mutable state should be altered during the lifetime of the app. The rest of the app relies on the
 * immutability of the immutable part of the searching state.
 *
 * */

import { CALCULATE_SEARCHED_ROW_KEYS, SET_IMMUTABLE_SEARCHING_DATA, SET_SEARCH_QUERY } from "../actions/searching";
import { calculateSearchedDataKeys } from "../../utils/data.transformations/searchedDataKeys";


export const initialImmutableSearchingState = {
    fields: [],
    searchIndex: {}
};

export function immutableSearching(state = initialImmutableSearchingState, action) {
    switch (action.type) {

        case SET_IMMUTABLE_SEARCHING_DATA:
            return {
                ...state,
                fields: action.fields,
                searchIndex: action.searchIndex,
            };

        default:
            return state
    }
}


export const initialMutableSearchingState = {
    searchQuery: '',
    searchedRowKeys: []
};

export function mutableSearching(state = initialMutableSearchingState, action) {
    switch (action.type) {

        case SET_SEARCH_QUERY:
            return {
                ...state,
                searchQuery: action.searchQuery
            };

        case CALCULATE_SEARCHED_ROW_KEYS:

            const searchedRowKeys = calculateSearchedDataKeys(
                action.initialRowKeys, state.searchQuery, action.searchIndex
            );

            return {
                ...state,
                searchedRowKeys: searchedRowKeys
            };

        default:
            return state
    }
}
